<template>
  <div class="modal-mask" v-if="show">
    <div class="modal-wrapper">
      <button class="popup-close" @click.prevent="cancel">
        <img src="../../assets/images/common/btn-popup-close.png" alt="닫기"/>
      </button>
      <div class="modal-container">
        <span>{{guideTitle}}</span>
        <span>{{guideText}}</span>
        <div class="modal-button">
          <button type="button" @click.prevent="cancel">취소</button>
          <a href="#" @click.prevent="confirm">이동하기</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    componentName: 'PpvConfirm',
    data () {
      return {
        show: false,
        confirmFn: null,
        guideTitle: '',
        guideText: ''
      }
    },
    methods: {
      cancel () {
        this.show = false
      },
      confirm () {
        this.confirmFn()
      }
    },
    mounted () {
      this.$events.$on('OPEN_PPV_POPUP', (ppvConfirmFn, guideTitle, guideText) => {
        this.guideTitle = guideTitle
        this.guideText = guideText
        this.show = true
        this.confirmFn = ppvConfirmFn
      })
    }
  }
</script>
<style scoped>
  .modal-mask{
    position: fixed;
    display: table;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /*z-index: 1;*/
    background-color: rgba(0, 0, 0, .8);
  }
  .modal-wrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    /*z-index: 2;*/
    width: 520px;
    margin: 0;
  }
  .popup-close{
    position: absolute;
    right: -35px;
  }
  .modal-container{
    width: 520px;
    height: auto;
    margin: 0 auto;
    padding: 40px 0;
    background-color: #252525;
    border-radius: 8px;
  }
  .modal-container>span{
    display: inline-block;
    width: 100%;
    text-align: center;
    color: #a5a5a5
  }
  .modal-container>span:first-child{
    margin-bottom: 28px;
    font-size:  24px;
    line-height: 26px;
    color: #fff
  }
  .modal-button{
    margin-top: 36px;
    text-align: center;
    font-size: 0
  }
  .modal-button button + a{
    margin-left: 8px;
  }
  .modal-button button,
  .modal-button a{
    display: inline-block;
    width: 159px;
    padding: 14px 0;
    text-align: center;
    font-size:  16px;
    line-height: 18px;
    color: #fff;
    background-color: #5e5e5e;
    border-radius: 30px;
  }
  .modal-button a{
    background-color: #1351f9
  }
</style>
